import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';
import ServicesProvided from './ServicesProvided';
import DiscountArea from './DiscountArea';
import PaymentSchedule from './PaymentSchedule';

class ServicesAndPayment extends React.PureComponent {
  invoicesExist = invoices => !invoices || !invoices.length || !invoices.length === 0;

  render() {
    const { contract } = this.props;

    // takes in currency (like 'EUR') and returns the symbol (like the euro symbol os the '$' for 'USD')
    const currencySymbol = CurrencyHelpers.getCurrencySymbol(contract.currency);

    // make sure we have invoices to display, if not return null/nothing
    if (this.invoicesExist(contract.invoices)) {
      return null;
    }

    return (
      <div className="contract-html">
        <ServicesProvided contract={contract} currencySymbol={currencySymbol} />
        <DiscountArea contract={contract} currencySymbol={currencySymbol} />
        <PaymentSchedule contract={contract} currencySymbol={currencySymbol} />
      </div>
    );
  }
}

ServicesAndPayment.propTypes = {
  contractFlow: PropTypes.object,
};

// Specifies the default values for props:
ServicesAndPayment.defaultProps = {
  contractFlow: {},
};

export default ServicesAndPayment;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/ServicesAndPayment/index.js